"use strict";
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomStatusDuration = void 0;
var CustomStatusDuration;
(function (CustomStatusDuration) {
    CustomStatusDuration["DONT_CLEAR"] = "";
    CustomStatusDuration["THIRTY_MINUTES"] = "thirty_minutes";
    CustomStatusDuration["ONE_HOUR"] = "one_hour";
    CustomStatusDuration["FOUR_HOURS"] = "four_hours";
    CustomStatusDuration["TODAY"] = "today";
    CustomStatusDuration["THIS_WEEK"] = "this_week";
    CustomStatusDuration["DATE_AND_TIME"] = "date_and_time";
    CustomStatusDuration["CUSTOM_DATE_TIME"] = "custom_date_time";
})(CustomStatusDuration || (exports.CustomStatusDuration = CustomStatusDuration = {}));
